import { runQuery } from '../graphQl'
import * as tenantConfig from '@/api/query/tenantConfigFeature'
import config from '@/config'
import http from '../http'
import store from '../../store'

export const GetTenantConfigTypes = () => {
  let conditions = null
  if (store.getters?.collaborator) {
    conditions = {
      tenant_id: {
        _eq: store.getters?.collaboratorId
      }
    }
  }
  return runQuery(tenantConfig.getTenantConfig(), { conditions }, 'tenant')
}

export const updateTenantCofig = async (selectedTab, sequenceValues) => {
  const updateTenant = {
    tenant_feature_configuration: {}
  }
  if (selectedTab === 'MATERIAL') {
    updateTenant.tenant_feature_configuration.MATERIAL = {
      SEQUENCE_TEMPLATE_DEFAULT: sequenceValues.MATERIAL.id
    }
    if (sequenceValues.PRODUCT_CODE) {
      updateTenant.tenant_feature_configuration.PRODUCT_CODE = {
        SEQUENCE_TEMPLATE_DEFAULT: sequenceValues.PRODUCT_CODE.id
      }
    }
  }
  if (selectedTab === 'FACTORIES') {
    updateTenant.tenant_feature_configuration.FACTORIES = {
      ...updateTenant.tenant_feature_configuration.FACTORIES,
      STORAGE_BINS: {
        SEQUENCE_TEMPLATE_DEFAULT: sequenceValues.STORAGE_BINS.id
      },
      RESOURCES: {
        SEQUENCE_TEMPLATE_DEFAULT: sequenceValues.RESOURCES.id
      }
    }
  }
  return http.POST(config.serverEndpoint + '/tenant/feature-config', updateTenant, 'tenant')
}
